import { restoreOfferComparisonState } from 'actions/OfferComparisonActions'
import { useAppDispatch } from 'hooks/reduxHooks'
import { useEffect } from 'react'
import { retrieveComparisonState } from 'storage/offerComparison'

export default function useOfferComparisonStateRestore() {
  const dispatch = useAppDispatch()

  useEffect(() => {
    const storedState = retrieveComparisonState()

    if (storedState) {
      dispatch(restoreOfferComparisonState(storedState))
    }
  }, [dispatch])
}
